import { useDispatch } from 'react-redux';
import Step_Upload_Images from '../../component/Step_Upload_Images';
import './style.scss';
import { useEffect } from 'react';

const StepUploadImages = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    window.document.title =
      'ImageEdit.ai | Generate or replace Catalogue Images with AI Models | Upload Image';
  }, []);
  return (
    <div className="step_upload_page_wrapper">
      <Step_Upload_Images />
    </div>
  );
};

export default StepUploadImages;
